import { lazy } from 'react';

export const TimesheetsPage = lazy(() => import('./TimesheetsPage'));
